export default __webpack_public_path__ + "static/media/menu-dark-green.4eb47afb.svg";